import React from "react";
import { Sparkles } from "lucide-react";

export default function AISupplementCard({ points }) {
  return (
    <div className="bg-purple-50 border border-purple-100 rounded-2xl p-4 mt-4">
      {/* Badge */}
      <div className="inline-flex items-center gap-1.5 bg-purple-100 text-purple-700 text-xs font-semibold px-2.5 py-1 rounded-full mb-3">
        <Sparkles size={11} />
        AI 补充
      </div>

      {/* Points */}
      <div className="space-y-3">
        {points.map((point) => (
          <div key={point.number} className="flex gap-3">
            <div className="w-5 h-5 rounded-full bg-purple-200 flex items-center justify-center shrink-0 mt-0.5">
              <span className="text-xs font-bold text-purple-700">{point.number}</span>
            </div>
            <div>
              <p className="text-sm font-semibold text-purple-900 mb-0.5">{point.title}</p>
              <p className="text-sm text-purple-700 leading-relaxed">{point.content}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
